"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightTabs = void 0;
const react_1 = __importStar(require("react"));
const classFunctions_1 = require("../../../utils/classFunctions");
const Icon_1 = require("../../Icon");
const Date_1 = require("./Date");
require("./index.scss");
const className = 'flight-tabs';
const FlightTabs = (props) => {
    var _a;
    const { tabs, modificators } = props;
    const [activeTab, setActiveTab] = react_1.default.useState(props.activeTab);
    (0, react_1.useEffect)(() => {
        setActiveTab(props.activeTab);
    }, [props.activeTab]);
    const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("div", { className: `${className}__header` },
            react_1.default.createElement("div", { className: `${className}__nav` }, tabs.map((flightTab, index) => (react_1.default.createElement("button", { onClick: () => {
                    setActiveTab(index);
                }, key: flightTab.date.toString(), className: `${className}__nav-item
                                ${index === activeTab ? `${className}__nav-item--active` : ''}` },
                react_1.default.createElement("div", { className: `${className}__nav-item-container` },
                    (flightTab === null || flightTab === void 0 ? void 0 : flightTab.isSelectedFlightInside) && (react_1.default.createElement("div", { className: `${className}__mark` },
                        react_1.default.createElement(Icon_1.Icon, { name: 'check-mark' }))),
                    react_1.default.createElement(Date_1.FlightTabDate, { date: flightTab.date, className: `${className}__date` }),
                    react_1.default.createElement("div", { className: `${className}__price` }, flightTab.price && (react_1.default.createElement(react_1.default.Fragment, null,
                        "ab ",
                        react_1.default.createElement("strong", null, flightTab.price)))))))))),
        react_1.default.createElement("div", { className: `${className}__content` }, (_a = tabs[activeTab]) === null || _a === void 0 ? void 0 : _a.content)));
};
exports.FlightTabs = FlightTabs;
//# sourceMappingURL=index.js.map